import { createApiSlice } from "@common";
import { CRUD_SEPARATION_REASON } from "@routes";

const apiConfig = [
  { name: "addSeparationReason",    method: "post",   url: CRUD_SEPARATION_REASON, stateKey: "message" },
  { name: "getSeparationReason",    method: "get",    url: CRUD_SEPARATION_REASON, stateKey: "data"    },
  { name: "getSeparationReasonById",    method: "get",    url: CRUD_SEPARATION_REASON, stateKey: "data"    },
  { name: "updateSeparationReason", method: "put",    url: CRUD_SEPARATION_REASON, stateKey: "message" },
  { name: "deleteSeparationReason", method: "delete", url: CRUD_SEPARATION_REASON, stateKey: "message" },
];

const customReducers = {
  initialState: { data: [], additionalData: [] },
  reducers: {
    setAdditionalData: (state, action) => { state.additionalData = action.payload; },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice("productType", apiConfig, customReducers);
const SeparationReasonSlice = slice;

export default SeparationReasonSlice.reducer;

export const { addSeparationReason, getSeparationReason,getSeparationReasonById, updateSeparationReason, deleteSeparationReason } = thunks;
export const { rowSelect } = actions;
